import { render, staticRenderFns } from "./CoinHistory.vue?vue&type=template&id=3045a7e8"
import script from "./CoinHistory.vue?vue&type=script&lang=js"
export * from "./CoinHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports